<header class="navbar navbar-dark sticky-top bg-dark p-0 shadow">
  <div class="col-md-6 col-sm-6 col-logo-mobile d-inline">
    <button
      (click)="showhideFilters()"
      class="navbar-toggler position-absolute d-md-none collapsed"
      type="button"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <a href="#" class="navbar-brand fw-bold"
      ><img src="assets/img/logo_affinity.svg" /><span class="navbar-title"
        >Data Quality Web</span
      ></a
    >
    <button
      *ngIf="!isDetail()"
      type="button"
      class="btn btn-sm btn-outline-light d-inline px-4 btn-filtros {{
        btnClass
      }}"
      (click)="showhideFilters()"
    >
      <img src="assets/img/icon-filtros.svg" class="mx-1" /> Filtros
    </button>
  </div>
  <div class="navbar-nav col-md-6 col-icons-mobile text-right d-inline">
    <div class="nav-item text-nowrap">
      <span
        class="fa-stack fa-3x"
        [attr.data-count]="posWarningsCount$ | async"
      >
        <a class="nav-link px-3 d-inline fs-5"
          ><img src="assets/img/icon-alert.svg" (click)="showModalWarnings()" />
        </a>
      </span>

      <a href="#" class="nav-link px-1 d-inline navbar-nav-name"
        >{{ userName }}
      </a>
      <a href="#" class="nav-link px-3 d-inline fs-5" (click)="logout()"
        ><img src="assets/img/icon-logout.svg"
      /></a>
    </div>
  </div>
</header>
